import './MaskedInput.scss';
import React, { useState, useEffect } from 'react';
import Cleave from 'cleave.js/react';
import { LFEBeaconError } from '../LFEBeaconComponents';
import { isFieldRequired } from 'utils/Validation';

const cleaveOptions = {
  'ssn': {
    blocks: [3,2,4],
    delimiter: '-',
    numericOnly: true
  },
  'accountNum': {
    blocks: [30]
  }
}

const validateValue = (value, validationFunc, required ,maxlength, minlength) =>{
  let validateResult = false;
  let lengthCheck = false;
  validateResult = validationFunc(value);
  if (value.length >= minlength && value.length <= maxlength){
    lengthCheck = true
  }
  if (required && !isFieldRequired(value)){
    return 'Required'
  } else if (!validateResult){
    return 'Invalid entry'
  } else if(!lengthCheck){
    return 'Invalid length'
  }
  return ''
}

const MaskedInput = ({
  id,
  label,
  onChange,
  type,
  maxlength,
  minlength,
  validation,
  required,
  value
}) => {
  useEffect(() => {
    const queryValue = '#' + id;
    const inputField = document.querySelector(queryValue);
    if(inputField) {
      inputField.type = 'password';
    }
  }, []) // eslint-disable-line
  const [isValid, setIsValid] = useState('')
  const [isMasked, setIsMasked] = useState(true);
  const onCustomChange = event => {
    const queryValue = '#' + id;
    const inputField = document.querySelector(queryValue);

    if(inputField) {
      isMasked ? inputField.type = 'password' : inputField.type = 'text';
    }

    onChange(event.target.rawValue);

  }

  const handleButtonClick = event => {
    setIsMasked(!isMasked);
    const queryValue = '#' + id;
    const inputField = document.querySelector(queryValue);
    if(inputField.type === 'text') {
      inputField.type = 'password';
    }else {
      inputField.type = 'text';
    }
  }

  const onBlurValid = event => {
    setIsValid(validateValue(value, validation, required, maxlength, minlength));
  }
  return <>
    <div>
      <label className='masked-input-label'
             htmlFor={id}>
        {label}
      </label>
    </div>
    { isValid && <LFEBeaconError message={isValid}/> }
    <div className="masked-input-container">
      <Cleave className="masked-input-field"
              id={id}
              options={cleaveOptions[type]}
              value={value}
              onChange={(event) => onCustomChange(event)}
              onBlur={(event) => onBlurValid(event)}/>
      <span>
      <button className="show-hide-button"
              onClick={(e) => handleButtonClick(e)}>
        {isMasked ? 'Show' : 'Hide'}
      </button>
    </span>
    </div>
  </>
}

export default MaskedInput;